/**
 * Markdown Block Configuration
 *
 * Registry config for the markdown/rich text block type.
 */

import { FileText } from "lucide-react";
import { MarkdownBlock } from "@/canvas/components/blocks/MarkdownBlock";
import type { BlockConfig } from "../types";

export const markdownBlockConfig: BlockConfig<"markdown"> = {
  type: "markdown",
  component: MarkdownBlock,
  icon: FileText,
  iconClassName: "text-stone-500",
  label: "canvas.blockTypes.markdown",
  defaultContent: () => ({ text: "" }),
};
